<template>
    <div>
        <form-group label="Start Date" name="start_date">
            <datepicker
                    placeholder="Select start date"
                    id="start_date"
                    name="start_date"
                    v-model="start_date"
            />
        </form-group>

        <form-group label="End Date" name="end_date" v-if="start_date">
            <datepicker
                    placeholder="Select end date"
                    id="end_date"
                    name="end_date"
                    v-model="end_date"
            />
        </form-group>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: ['type', 'startDate', 'endDate'],

        data() {
            return {
                start_date: null,
                end_date: null,
            }
        },

        mounted() {
            if (this.startDate) {
                this.start_date = this.startDate
            }
            if (this.endDate) {
                this.end_date = this.endDate
            }
        },

        methods: {},

        computed: {

            minStartDate() {
                if (this.type === 'child-care-leave' || this.type === 'reservist-service') {
                    return moment().format('YYYY-MM-DD')
                }
                return moment().add(2, 'months').startOf('month').format('YYYY-MM-DD');
            },

            minEndDate() {
                if (this.type === 'days-off') {
                }
                return (this.start_date ? moment(this.start_date, 'YYYY-MM-DD') : this.minStartDate).format('YYYY-MM-DD');
            },

            maxEndDate() {
                if (this.type === 'days-off') {
                    return (this.start_date ? moment(this.start_date, 'YYYY-MM-DD') : this.minStartDate).add(2, 'days').format('YYYY-MM-DD');
                }
                if (this.type == 'pattern-flying') {
                    if (moment().format('D') >= 20) {
                        return moment().add(4, 'months').startOf('month').format('YYYY-MM-DD')
                    }
                    return moment().add(3, 'months').startOf('month').format('YYYY-MM-DD')
                }
                return null;
            }

        },

        watch: {
            end_date(val) {
                if (val) {
                    this.$parent.$emit('completed')
                }
            }
        }

    }
</script>